import { Box, styled } from "@mui/material";

export const SideNavigationWrapper = styled(Box)(() => {
    return {
        "& .MuiListItemButton-root:hover": {
            background: "#FAF6F6 !important",
            color: "#791377 !important",
            "& .MuiListItemIcon-root>svg": {
                stroke: "#791377",
            },
            "& .arrow-box>svg": {
                fill: "#791377"
            }
        },
    }
})